import React from "react";
import CustomDialogue from "../CustomDialogue";
import { ModalConfig } from "../../hooks/useModal";
import Redeem from "../Redeem";

type Props = {
  modalConfig: ModalConfig;
};

const RedeemModal = ({ modalConfig }: Props) => {
  return (
    <CustomDialogue modalConfig={modalConfig}>
      <Redeem />
    </CustomDialogue>
  );
};

export default RedeemModal;
